import React, {useState} from 'react';
import {CheckBox} from 'grevlingui';

export const Exercise = ({
                             exercise,
                             setExercise,
                             editing,
                             className,
                             sessionIndex,
                             sessions
                         }) => {
    const [showHistory, setShowHistory] = useState(false);
    const {name, sets, reps, weight, marked} = exercise;

    const copyHistory = (val) => {
        const {weight, reps, sets} = val;
        setExercise({...exercise, weight, reps, sets});

    }

    if (!editing && (!reps || !weight || !sets))
        return null;


    const setThing = (key, value) => setExercise({
        ...exercise,
        [key]: value
    })

    const renderThing = (key, value) => (
        editing ? (<input
            type="number"
            value={value ?? ''}
            onChange={(e) => {
                setThing(key, e.target.value)
            }}
        />) : value
    )

    let prevMarked = false;
    let history = null;

    (() => {
        if (!sessions) return;
        // if (name !== 'Kranglesprang') return;
        const v = Object.values(sessions)
        const f = (v.filter((s, i)  => {
            return i > sessionIndex &&  s.exercises.some(e =>
                e.name.toLowerCase() === name.toLowerCase() &&
                !!e.weight &&
                !!e.reps &&
                !!e.sets
            );
        }) ?? []).slice(0, 4);
        const h = f.map(s => s.exercises.find(e => e.name === name));
        prevMarked = h[0] && !!h[0].marked;

        const empty = e => !(e.reps?.length > 0 || e.sets?.length > 0  || e.weight?.length > 0)

        history = <div
            className="history"
        >
            <CheckBox
                checked={marked}
                setChecked={() => {
                    setExercise(({
                        ...exercise,
                        marked: !exercise.marked
                    }))
                }}
                className="marker"
                color="white"
                label={empty(exercise) ? 'Slett' : 'Øk'}
            />
            {f.length === 0 ? <div/> : h.map((prev, i) => (
                <div
                    key={`old-${prev.name}-${i}`}
                    className="previousSession"
                    onClick={() => copyHistory(h[0])}
                >
                    <span>{prev.weight}</span> kg x <span>{prev.reps}</span> x <span>{prev.sets}</span>
                </div>
            ))}
        </div>
    })();



    return (
        <div className={`exercise ${className} ${prevMarked ? 'highlighted' : ''}`}>
            <div className="main">
                <div
                    className={`exerciseName ${history ? 'withHistory' : ''}`}
                    onClick={() => {
                        // if (!history) return;
                        setShowHistory(prev => !prev);
                    }}
                >
                    {name}
                </div>
                <div>
                    {renderThing('weight', weight)}
                    {' kg x '}
                    {renderThing('reps', reps)}
                    {' x '}
                    {renderThing('sets', sets)}
                </div>
            </div>
            {showHistory && history}
        </div>
    );
}